<div class="col-12 confirmation-section">
    <div class="section-title">Payment method</div>
    <div class="section-detail-wrapper">
        <div class="section-details-header">Bank Deposit payment details</div>
        <div class="section-detail-subhead">
           Amount to pay: 
        </div>
        <div class="section-detail-value">
            {{getPaymentAmount()}}
        </div>
        <div class="section-detail-subhead">
            Bank: 
        </div>
        <div class="section-detail-value">
            {{summary?.agencyBankName}}
        </div>
        <div class="section-detail-subhead">
            Account name: 
        </div>
        <div class="section-detail-value">
            {{summary?.agencyBankAccName}}
        </div>
        <div *ngIf="summary?.agencyBSBCode && summary?.agencyBSBCode !== ''" class="section-detail-subhead">
            BSB:
        </div>
        <div *ngIf="summary?.agencyBSBCode && summary?.agencyBSBCode !== ''" class="section-detail-value">
            {{summary?.agencyBSBCode}}
        </div>
        <div class="section-detail-subhead">
            Account number:
        </div>
        <div class="section-detail-value">
            {{summary?.agencyBankAccNumber}}
        </div>
        <div *ngIf="summary?.eftDescription && summary?.eftDescription !== ''" class="section-detail-subhead">
            Description:
        </div>
        <div *ngIf="summary?.eftDescription && summary?.eftDescription !== ''" class="section-detail-value">
            {{summary?.eftDescription}}
        </div>
        <div *ngIf="summary?.eftParticulars && summary?.eftParticulars !== ''" class="section-detail-subhead">
            Particulars:
        </div>
        <div *ngIf="summary?.eftParticulars && summary?.eftParticulars !== ''" class="section-detail-value">
            {{summary?.eftParticulars}}
        </div>
        <div *ngIf="summary?.eftCode && summary?.eftCode !== ''" class="section-detail-subhead">
            Code:
        </div>
        <div *ngIf="summary?.eftCode && summary?.eftCode !== ''" class="section-detail-value">
            {{summary?.eftCode}}
        </div>
        <div class="section-detail-subhead">
            Reference:
        </div>
        <div class="section-detail-value">
            {{summary?.eftReference}}
        </div>
        <div class="section-details-header">International payment details you may require</div>
        <div class="section-detail-subhead">
            Branch address:
        </div>
        <div class="section-detail-value">
            {{summary?.internationalBankBranch}}
        </div>
        <div class="section-detail-subhead">
            BIC/Swift code:
        </div>
        <div class="section-detail-value">
            {{summary?.swiftCode}}
        </div>
    </div>
</div>